import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';

import { fetchSuiteServiceRequests, clearServiceRequests } from '../../store/actions/serviceRequests';
import { selectServiceRequests } from '../../store/selectors/serviceRequests';
import ServiceRequestsTable from '../../components/ServiceRequestsTable/ServiceRequestsTable_legacy';
import { setSearch, clearSearch }  from '../../store/actions/search';
import Loader from '../../components/Loader';
import { selectLoader } from '../../store/selectors/loader';
import { PATHS } from '../../common/constants';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { fetchSuiteServiceRequestCSVExportDownloadList } from '../../store/actions/csvExport';

class SuiteServiceRequests extends Component {
  state = {
    searchString: ''
  }
  componentDidMount() {
    const { suite, onFetchSuiteServiceRequests, clearSearch,user } = this.props;
    onFetchSuiteServiceRequests(suite.id,user.roles[0].role.name, 1, '');
    clearSearch();
  }

  loadMoreServiceRequest = async () => {
    const { onFetchSuiteServiceRequests, paginationCount, suite,user } = this.props;
      onFetchSuiteServiceRequests(suite.id,user.roles[0].role.name, paginationCount+1, this.state.searchString)
  }
  search = async (text) => {
    this.setState({ searchString: text})
    const { onFetchSuiteServiceRequests, suite,user } = this.props;
      onFetchSuiteServiceRequests(suite.id,user.roles[0].role.name, 1, text, true)
  }

  downloadCSV(){
    const { fetchSuiteServiceRequestCSVExportDownloadList,user,suite } = this.props;
    fetchSuiteServiceRequestCSVExportDownloadList(suite.id,user.roles[0].role.name, this.state.searchString)
  }

  render() {
    const { suite, serviceRequests, setSearch, loader } = this.props;
    return (
      loader ? <Loader /> :
      <ServiceRequestsTable
        download= {() => this.downloadCSV()}
        propertyDisabled = {true}
        serviceRequests={serviceRequests}
        // onSearch={e => setSearch({ serviceRequests: e.target.value.trim()})}
        onSearch = {e => this.search(e.target.value.trim())}
        serviceRequest={{ property_id: suite.propertyId,propertyId:suite.propertyId,suiteId:suite.id, suite_id: suite.id,suiteFloorPLan:suite.floorPlanURL && suite.floorPlanURL.length > 0 ? suite.floorPlanURL : '' }}
        loadServiceRequest = {this.loadMoreServiceRequest}
        from='Suite'
        navigateTo={PATHS.SUITES_VIEW.replace(':id', suite.propertyId + "&"+suite.id)}
        introContent={true}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user:selectAuthenticatedUser(state),
  paginationCount: state.paginationCount.count,
  pageCount: state.serviceRequestStatusPageCount.pageCount,
  serviceRequests: selectServiceRequests(state),
  loader: selectLoader(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  onFetchSuiteServiceRequests: fetchSuiteServiceRequests,
  setSearch,
  clearSearch,
  clearServiceRequests: clearServiceRequests,
  fetchSuiteServiceRequestCSVExportDownloadList:fetchSuiteServiceRequestCSVExportDownloadList
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SuiteServiceRequests);
